import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import {store} from './Redux/store'
import { Provider } from 'react-redux'
import reportWebVitals from './reportWebVitals';

// User-Friendly Fallback for Chunk Errors
window.addEventListener('error', (event) => {
    if (event.message && event.message.includes('Loading chunk')) {
      console.error('Chunk Load Error:', event.message);
    //   alert('An error occurred while loading the app. Please refresh the page.');
      window.location.reload();
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
